import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject, OnInit } from '@angular/core';
import { HlrRates } from '@helpers/types/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlarisEditPanelService, EditPanelInputData } from '@campaign-portal/components-library';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RatesService } from '../rates.service';
import { CurrenciesService } from '../../currencies/currencies.service';

@Component({
	selector: 'app-edit-rate',
	templateUrl: './edit-rates.component.html',
	styleUrl: './edit-rates.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EditRateComponent implements OnInit {
	readonly errors: { key: string; value: string }[] = [
		{key: 'mask', value: 'gl.errors.invalid_format'},
		{key: 'required', value: 'gl.errors.required'}];
	readonly rate: HlrRates = {
		id: null,
		currencyId: null,
		currencyName: '',
		startDate: null,
		rate: null,
	};
	readonly form = new FormGroup({
		id: new FormControl<number | null>(null),
		currencyId: new FormControl<number | null>(null, [Validators.required]),
		startDate: new FormControl<string | null>(null, [Validators.required]),
		rate: new FormControl<number | null>(null, [Validators.required])
	});
	
	readonly separator = ', ';
	private readonly destroyRef = inject(DestroyRef);
	
	constructor(
			@Inject(EditPanelInputData) private readonly inputData: { rate?: HlrRates },
			public readonly ratesService: RatesService,
			private readonly editPanel: AlarisEditPanelService,
			public readonly currenciesService: CurrenciesService
	) {
		if ( this.inputData.rate ) {
			this.rate = this.inputData.rate;
		}
	}
	
	ngOnInit(): void {
		this.reset();
	}
	
	reset(): void {
		const rate = structuredClone(this.rate);
		this.form.reset(rate);
	}
	
	save(): void {
		const start = new Date(this.form.controls.startDate.value as string);
		start.setUTCHours(0,0,0,0);
		const currency = {
			id: this.form.controls.id.value,
			currencyId: this.form.controls.currencyId.value,
			startDate: start.toJSON(),
			rate: this.form.controls.rate.value
		};
		this.ratesService.update(currency)
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((resp) => {
				if (
					resp.data[0]?.id
				) {
					this.editPanel.close(true);
				}
			});
	}
	
	close(): void {
		this.editPanel.close(false);
	}

	displayWithName = (currencyId: number | null): string  => {
		if ( currencyId ) {
			return this.currenciesService.map.get(currencyId)?.name || '';
		}
		return '';
	}

}
